import { createBrowserHistory } from 'history'; // eslint-disable-line
import { syncHistoryWithStore } from 'mobx-react-router';
import routerStore from '../stores/routerStore';

const browserHistory = createBrowserHistory();

export const history = syncHistoryWithStore(browserHistory, routerStore);
